import * as React from 'react'
import { ComponentProps } from 'react'

import {
  Box,
  Button,
  Variants as ButtonVariants,
  Icon,
} from '@factorialco/deprecated-design-system'

export type Action = {
  label?: string
  type: ButtonVariants
  icon?: ComponentProps<typeof Icon.Medium>['icon']
  disabled?: boolean
  onClick: () => void
  ariaLabel?: string
}
interface Props {
  actions?: Action[]
}

const Actions: React.FC<Props> = ({ actions = [] }) => {
  return (
    <Box flexDirection="row" gap="s16" justifyContent="center">
      {actions.map((action, index) => (
        <Button
          key={index}
          onClick={action.onClick}
          type={action.type}
          iconName={action.icon}
          disabled={action.disabled || false}
          aria-label={action.ariaLabel}
        >
          {action?.label}
        </Button>
      ))}
    </Box>
  )
}

export default Actions
